import React from 'react';
import { StaticPageLayout } from '../StaticPageLayout';
import styles from '../Education/ScienceOfTime.module.scss';
import { usePageSEO } from '../../../hooks/usePageSEO';
import { tokens } from '../../../styles/tokens';

export const AboutUs: React.FC = () => {
  usePageSEO({
    title: "About Us - The MyMinu Team",
    description: "We are parents building the tools we wished we had. Learn about our mission to make family routines peaceful.",
    url: window.location.origin + "/about"
  });

  return (
    <StaticPageLayout>
      <div className={styles.container}>
        
        <div className={styles.header}>
          <h1>About Us</h1>
          <p className={styles.subtitle} style={{ maxWidth: '600px', margin: '0 auto' }}>
            We’re parents, technology advocates, and a team of highly motivated individuals building the tools we wished we had.
          </p>
        </div>

        <section className={styles.section} style={{ textAlign: 'center', fontSize: '1.25rem', lineHeight: '1.8' }}>
          <p>
            We want to bring the methods and tools that have worked for us to the rest of the world, to make routines work for you and your kids.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Our Mission</h2>
          <div style={{ background: 'white', padding: '32px', borderRadius: '16px', boxShadow: '0 4px 12px rgba(28, 28, 28, 0.05)', borderLeft: `4px solid ${tokens.sunYellow}` }}>
            <p>
              Like many of you, we struggled with the daily chaos—morning meltdowns, bedtime battles, and the constant refrain of "five more minutes!" We realized that our children weren't trying to be difficult; they simply didn't experience time the way we did.
            </p>
            <p style={{ marginBottom: 0 }}>
              We built <strong>MyMinu</strong> to bridge that gap. By turning abstract time into concrete, visual, and playful moments, we found that routines stopped being a struggle and started being a way to connect.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2>Why We Do This</h2>
          <div className={styles.twoColumn} style={{ alignItems: 'flex-start' }}>
            <div>
              <p>
                We believe that <strong>structured freedom</strong> gives children the confidence to explore. When a child knows what comes next, they feel safe. When they can "see" time passing, they feel in control.
              </p>
              <p>
                We're not just building an app; we're building the tool we wished we had when our kids were toddlers. We hope it brings as much peace and joy to your home as it has to ours.
              </p>
            </div>
            <div style={{ background: tokens.paperCream, padding: '24px', borderRadius: '16px', border: '1px solid rgba(28,28,28,0.1)' }}>
              <h3 style={{ marginTop: 0, fontSize: '1.4rem' }}>Our Values</h3>
              <ul className={styles.tipsList} style={{ margin: 0, padding: 0 }}>
                <li style={{ padding: '12px 0', background: 'transparent', boxShadow: 'none', borderBottom: '1px solid #E0E0E0' }}>❤️ Empathy First</li>
                <li style={{ padding: '12px 0', background: 'transparent', boxShadow: 'none', borderBottom: '1px solid #E0E0E0' }}>🧠 Science-Backed</li>
                <li style={{ padding: '12px 0', background: 'transparent', boxShadow: 'none' }}>🎮 Playful Design</li>
              </ul>
            </div>
          </div>
        </section>

        <div className={styles.cta} style={{ marginTop: '40px', padding: '48px 24px' }}>
          <h3 style={{ fontSize: '24px', marginBottom: '16px' }}>Here’s to fewer battles and more high-fives.</h3>
          <p style={{ color: tokens.paperCream, fontSize: '1.1rem', marginBottom: '0' }}>— The MyMinu Team</p>
        </div>

      </div>
    </StaticPageLayout>
  );
};
